import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../assets/contexts/AuthContext';
import { useRightSidebar } from '../../../assets/contexts/RightSidebarContext';
import { requestNotificationUnreadCountRefresh } from '../../../assets/utils/comm/notificationUnreadCountEvents';

/** 알림 벨 아이콘 (모바일/태블릿 툴바용) */
const NotificationBellIcon = ({ className = '', style = {} }) => (
  <svg className={className} style={style} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

/**
 * 툴바 컴포넌트 (통합)
 * 원본 header-toolbar.html의 header-toolbar와 nav-toolbar fragment를 하나로 통합
 * 원본 JavaScript 동작과 동일하게 구현
 *
 * @param {string} variant - 'header' 또는 'nav' (기본값: 'header')
 * @param {function} onMenuClick - 모바일 메뉴 클릭 핸들러 (header variant일 때만 사용)
 */
const HeaderToolbar = ({ variant = 'header', onMenuClick }) => {
  const { isAuthenticated, logout } = useAuth();
  const { open: openRightSidebar } = useRightSidebar();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const userMenuRef = useRef(null);
  const searchToggleRef = useRef(null);
  const searchWrapRef = useRef(null);
  const searchInputRef = useRef(null);

  // 모바일/태블릿 헤더는 HeaderTop의 단일 폴링 결과를 구독만 수행
  useEffect(() => {
    if (!isAuthenticated) {
      setNotificationCount(0);
      return;
    }

    // HeaderTop이 먼저 받아둔 값이 있으면 즉시 반영
    if (typeof window.__unreadNotificationCount === 'number') {
      setNotificationCount(window.__unreadNotificationCount);
    }

    const handleUnreadCountUpdate = (event) => {
      const next = Number(event?.detail?.count);
      if (!Number.isNaN(next)) setNotificationCount(next);
    };
    window.addEventListener('notificationUnreadCountUpdated', handleUnreadCountUpdate);
    return () => window.removeEventListener('notificationUnreadCountUpdated', handleUnreadCountUpdate);
  }, [isAuthenticated]);
  // 외부 클릭 시 사용자 메뉴 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    if (showUserMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserMenu]);

  // 원본 JavaScript 동작과 동일하게 검색 토글 처리
  // 원본 main.js의 searchToggle 로직과 동일하게 구현
  useEffect(() => {
    if (!searchToggleRef.current || !searchWrapRef.current) return;

    const handleSearchToggle = (e) => {
      e.preventDefault();
      const toggle = searchToggleRef.current;
      const wrap = searchWrapRef.current;

      // 원본과 동일: siblings('.search-wrap-1') 찾기
      // React에서는 이미 ref로 연결되어 있음

      if (toggle.classList.contains('open')) {
        toggle.classList.remove('open');
        wrap.classList.remove('open');
      } else {
        toggle.classList.add('open');
        wrap.classList.add('open');

        // input에 focus (원본과 동일)
        const focusInput = () => {
          if (searchInputRef.current) {
            searchInputRef.current.focus();
          }
        };
        if (typeof queueMicrotask === 'function') {
          queueMicrotask(focusInput);
        } else {
          focusInput();
        }
      }
    };

    const toggle = searchToggleRef.current;
    toggle.addEventListener('click', handleSearchToggle);

    return () => {
      toggle.removeEventListener('click', handleSearchToggle);
    };
  }, []);

  // 원본 JavaScript가 장바구니와 모바일 메뉴를 처리하도록 DOM 구조만 제공
  // 원본 main.js의 이벤트 리스너가 자동으로 처리함

  // Header variant (상단 헤더용)
  if (variant === 'header') {
    return (
      <>
        <div className="header-action-wrap">
          {/* 돋보기 검색 버튼 - 주석처리 */}
          {/* <div className="header-action-style header-search-1">
          <a className="search-toggle" href="#" ref={searchToggleRef}>
            <i className="pe-7s-search s-open"></i>
            <i className="pe-7s-close s-close"></i>
          </a>
          <div className="search-wrap-1" ref={searchWrapRef}>
            <form action="#">
              <input
                ref={searchInputRef}
                placeholder="검색어를 입력하세요"
                title="통합검색"
                type="text"
              />
              <button className="button-search" type="submit">
                <i className="pe-7s-search"></i>
              </button>
            </form>
          </div>
        </div> */}
          {/* 로그인/사용자 메뉴 - 주석처리 */}
          {/* <div className="header-action-style" ref={userMenuRef} style={{ position: 'relative' }}>
          <a
            title="Login Register"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setShowUserMenu(!showUserMenu);
            }}
          >
            <i className="pe-7s-user"></i>
          </a>
          {showUserMenu && (
            <div className="dropdown-menu" style={{ display: 'block' }}>
              {!isAuthenticated ? (
                <>
                  <Link to="/login" onClick={() => setShowUserMenu(false)}>로그인</Link>
                  <Link to="/register" onClick={() => setShowUserMenu(false)}>회원가입</Link>
                </>
              ) : (
                <>
                  <Link to="/my-profile" onClick={() => setShowUserMenu(false)}>마이페이지</Link>
                  <a href="#" onClick={(e) => {
                    e.preventDefault();
                    logout();
                    setShowUserMenu(false);
                  }}>
                    로그아웃
                  </a>
                </>
              )}
            </div>
          )}
        </div> */}
          {/* 하트 위시리스트 버튼 - 주석처리 */}
          {/* <div className="header-action-style">
          <a title="Wishlist" href="/wishlist">
            <i className="pe-7s-like"></i>
          </a>
        </div> */}
          {/* 장바구니 버튼 - 주석처리 */}
          {/* <div className="header-action-style header-action-cart">
          <a className="cart-active" href="#">
            <i className="pe-7s-shopbag"></i>
            <span className="product-count bg-black">01</span>
          </a>
        </div> */}
          {/* 모바일/태블릿: 알림 종 + 햄버거 메뉴 버튼 (알림은 로그인 시에만 표시) */}
          <div className="header-action-style header-action-mobile-actions d-flex align-items-center gap-2 d-block d-lg-none">
            {isAuthenticated && (
              <button
                type="button"
                className="header-action-mobile-notification-btn"
                onClick={(e) => {
                  e.preventDefault();
                  requestNotificationUnreadCountRefresh();
                  openRightSidebar('notification');
                }}
                aria-label="알림 보기"
              >
                <span className="header-action-mobile-notification-icon-wrap">
                  <NotificationBellIcon className="header-action-mobile-notification-icon" style={{ width: 22, height: 22 }} />
                  {notificationCount > 0 && (
                    <span className="header-action-mobile-notification-badge" aria-hidden="true">
                      {notificationCount > 99 ? '99+' : notificationCount}
                    </span>
                  )}
                </span>
              </button>
            )}
            <button
              type="button"
              className="mobile-menu-active-button"
              onClick={(e) => {
                e.preventDefault();
                if (onMenuClick) {
                  onMenuClick();
                }
              }}
              aria-label="메뉴 열기"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <rect x="3" y="4" width="18" height="3" rx="1.5"></rect>
                <rect x="3" y="10.5" width="18" height="3" rx="1.5"></rect>
                <rect x="3" y="17" width="18" height="3" rx="1.5"></rect>
              </svg>
            </button>
          </div>
        </div>
        <style>{`
        .header-action-mobile-actions { gap: 8px; }
        .header-action-mobile-notification-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 6px;
          margin: 0;
          border: none;
          background: transparent;
          color: inherit;
          cursor: pointer;
          border-radius: 8px;
          transition: background 0.2s, opacity 0.2s;
        }
        .header-action-mobile-notification-btn:hover {
          background: rgba(0, 0, 0, 0.06);
          opacity: 0.9;
        }
        .header-action-mobile-notification-icon-wrap {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
        .header-action-mobile-notification-icon { display: block; }
        .header-action-mobile-notification-badge {
          position: absolute;
          top: -6px;
          right: -6px;
          min-width: 16px;
          height: 16px;
          padding: 0 4px;
          font-size: 10px;
          font-weight: 700;
          line-height: 16px;
          color: #fff;
          background: var(--theme-color-primary, #e97730);
          border: 1px solid #fff;
          border-radius: 8px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
        }
      `}</style>
      </>
    );
  }

  // Nav variant (사이드 네비게이션용)
  return (
    <div className="nav-layout__toolbar">
      <div className="nav-toolbar-search">
        <button
          type="button"
          className="nav-toolbar-btn search-toggle"
          title="Search"
          ref={searchToggleRef}
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          <i className="pe-7s-search"></i>
        </button>
        <div className="search-wrap-1 nav-search-wrap" ref={searchWrapRef}>
          <form action="#">
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Search…"
              autoComplete="off"
            />
            <button className="button-search" type="submit">
              <i className="pe-7s-search"></i>
            </button>
          </form>
        </div>
      </div>
      <div className="nav-toolbar-btn-wrapper" ref={userMenuRef} style={{ position: 'relative' }}>
        <button
          type="button"
          className="nav-toolbar-btn"
          title="User"
          onClick={(e) => {
            e.preventDefault();
            setShowUserMenu(!showUserMenu);
          }}
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          <i className="pe-7s-user"></i>
        </button>
        {showUserMenu && (
          <div
            className="dropdown-menu"
            style={{
              display: 'block',
              top: 'auto',
              bottom: '100%',
              left: '50%',
              right: 'auto',
              transform: 'translateX(-50%)',
              marginTop: 0,
              marginBottom: '10px'
            }}
          >
            {!isAuthenticated ? (
              <>
                <Link to="/login" onClick={() => setShowUserMenu(false)}>로그인</Link>
                <Link to="/register" onClick={() => setShowUserMenu(false)}>회원가입</Link>
              </>
            ) : (
              <>
                <Link to="/my-profile" onClick={() => setShowUserMenu(false)}>마이페이지</Link>
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    logout();
                    setShowUserMenu(false);
                  }}
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', width: '100%', textAlign: 'left' }}
                >
                  로그아웃
                </button>
              </>
            )}
          </div>
        )}
      </div>
      <a className="nav-toolbar-btn" href="/wishlist" title="Wishlist">
        <i className="pe-7s-like"></i>
      </a>
      <button
        type="button"
        className="nav-toolbar-btn cart-active header-action-cart"
        title="Cart"
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
      >
        <i className="pe-7s-shopbag"></i>
      </button>
    </div>
  );
};

export default HeaderToolbar;

